import React from 'react';
import { Routes, Route, Navigate } from 'react-router';
import { InvestorDocRequest } from '@/containers';
import {
  Investors,
  InvestorDetails,
  QuestionnaireAnswers,
  SumsubAnswers,
  Localization,
  TranslateQuestionnaire,
  Constructor,
  QuestionnairePage,
  ConstructorDocuments,
  DocumentPage,
  EditPage,
  ConstructorProducts,
  ProductPage,
  ProductAnswers,
  Settings,
  ConstructorScoringCategory,
  ScoringCategoryPage
} from '@/pages';
import { EditProductPage } from '@/pages/admin/Investors/ProductAnswers/edit';
import { Statics } from '@/pages/admin/Statics';
import { AdminLayout } from '@/layouts/AdminLayout';
import {
  InvestorActivity,
  InvestorDocuments,
  InvestorProducts,
  InvestorReferralRequests,
  ProfileInfoView,
  ProfileStatusAdmin
} from '@/components';

export const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path='investors'>
          <Route path=':type' element={<Investors />} />
        </Route>

        <Route path='investor'>
          <Route path=':id'>
            <Route element={<InvestorDetails />}>
              <Route index element={<ProfileInfoView />} />

              <Route path='questionnaires' element={<ProfileStatusAdmin adminView />} />

              <Route path='documents' element={<InvestorDocuments />} />

              <Route path='referrals' element={<InvestorReferralRequests />} />

              <Route path='products' element={<InvestorProducts />} />

              <Route path='activity' element={<InvestorActivity />} />
            </Route>
          </Route>
        </Route>

        <Route path='localization'>
          <Route index element={<Localization />} />

          <Route path=':id' element={<TranslateQuestionnaire />} />
        </Route>

        <Route path='constructorQuestionnaires'>
          <Route index element={<Constructor />} />

          <Route path=':id' element={<QuestionnairePage />} />
        </Route>

        <Route path='constructorDocuments'>
          <Route index element={<ConstructorDocuments />} />

          <Route path=':id' element={<DocumentPage />} />
        </Route>

        <Route path='constructorProducts'>
          <Route index element={<ConstructorProducts />} />

          <Route path=':id' element={<ProductPage />} />
        </Route>

        <Route path='constructorScoringCategory'>
          <Route index element={<ConstructorScoringCategory />} />

          <Route path=':id' element={<ScoringCategoryPage />} />
        </Route>

        <Route path='statics' element={<Statics />} />

        <Route path='settings' element={<Settings />} />
      </Route>

      <Route path='investor'>
        <Route path=':id'>
          <Route path='questionnaire'>
            <Route path=':questionnaireId'>
              <Route index element={<QuestionnaireAnswers />} />

              <Route path='edit' element={<EditPage />} />
            </Route>
          </Route>

          <Route path='product'>
            <Route path=':productId'>
              <Route index element={<ProductAnswers />} />

              <Route path='edit' element={<EditProductPage />} />
            </Route>
          </Route>

          <Route path='sumsub-verification' element={<SumsubAnswers />} />

          <Route path='documents'>
            <Route path=':requestId' element={<InvestorDocRequest />} />
          </Route>
        </Route>
      </Route>

      {/* Fallback redirect */}
      <Route path='*' element={<Navigate to='/investors/PERSONAL' replace />} />
    </Routes>
  );
};
